import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isSafeRedirectUrl } from '@core/routing/safe-redirect-url';
import { AuthService } from '@features/auth/data-access/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  const returnUrl = isSafeRedirectUrl(state.url) ? state.url : undefined;

  return router.createUrlTree(['/login'], returnUrl ? { queryParams: { returnUrl } } : undefined);
};
